export default "__VITE_ASSET__BoFbg4iO__"